function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from "react";
import "./HolidayImport.css";
import DatePicker from "react-datepicker";
import Button from "react-bootstrap/Button";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ControlLabel from "react-bootstrap/FormLabel";
import FormControl from "react-bootstrap/FormControl";
import FormGroup from "react-bootstrap/FormGroup";
import { MdDeleteForever, MdModeEdit } from "react-icons/md";
import { HiUpload } from "react-icons/hi";
import { ADD_HOLIDAY_MUTATION, HOLIDAY_LIST_QUERY, DELETE_HOLIDAY_MUTATION, EDIT_HOLIDAY_MUTATION, IMPORT_HOLIDAY_MUTATION, IMPORT_OLD_DATA_HOLIDAY_MUTATION, IMPORT_OLD_DATA_NO_HOLIDAY_MUTATION, LAST_YEAR_HOLIDAY_QUERY, ADD_USER_HOLIDAY_MUTATION } from "./query";
import { useQuery, useMutation } from "@apollo/client";
import { FilterContext, UserContext } from "../index";
import Loader from "./../Loader/Loader";
import { toast } from "react-toastify";
import moment from "moment-timezone";
import Excel from "exceljs/dist/es5/exceljs.browser";
import { saveAs } from "file-saver";
import { read, utils } from "xlsx";
import { FaRegLightbulb } from "react-icons/fa";
import { LeaveManagementEnableFeature } from "./../AdminViewLeave/AdminViewLeave";
import Accordion from "react-bootstrap/Accordion";
import { HiLockClosed } from "react-icons/hi";
import SearchBar from "../SearchBar";
import classNames from "classnames";
import { GET_USER_LISTING_QUERY } from "./../MonthlyAttendance/query";
import { BsEyeFill, BsInfoCircle } from "react-icons/bs";
import { FiCalendar, FiLock, FiUnlock } from "react-icons/fi";
import { GiSandsOfTime } from "react-icons/gi";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { isRateLimited, rateLimitMessage } from "../utils";
var holidayTypeFilter = [{
  label: "Public Holiday",
  value: "public-holiday"
}, {
  label: "Office Holiday",
  value: "office-holiday"
}, {
  label: "Floater Holiday",
  value: "floater-holiday"
}];
var dayTypeList = [{
  name: "Full Day",
  value: "full-day"
}, {
  name: "Half Day - 1st Half",
  value: "half-day-first-half"
}, {
  name: "Half Day - 2nd Half",
  value: "half-day-second-half"
}];
var holidayTypeList = [{
  name: "Public Holiday",
  value: "public-holiday"
}, {
  name: "Office Holiday",
  value: "office-holiday"
}, {
  name: "Floater Holiday",
  value: "floater-holiday"
}];
var AddHolidaySchema = Yup.object().shape({
  date: Yup.string().trim().required("Required"),
  holidayTitle: Yup.string().trim().required("Required"),
  holidaySession: Yup.string().trim().required("Required"),
  holidayType: Yup.string().trim().required("Required")
});
var LIMIT = 15;
var offsets = 0;
var HolidayImport = function HolidayImport(props) {
  var _useState = useState(new Date()),
    _useState2 = _slicedToArray(_useState, 2),
    holidayYear = _useState2[0],
    setHolidayYear = _useState2[1];
  var _useState3 = useState(moment(holidayYear).format("YYYY")),
    _useState4 = _slicedToArray(_useState3, 2),
    holidayYearQuery = _useState4[0],
    setHolidayYearQuery = _useState4[1];
  var _React$useContext = React.useContext(UserContext),
    user = _React$useContext.user;
  var _React$useContext2 = React.useContext(FilterContext),
    organisationId = _React$useContext2.organisationId,
    role = _React$useContext2.role,
    organisationSettings = _React$useContext2.organisationSettings,
    organisationBilling = _React$useContext2.organisationBilling,
    leaveSettingsUser = _React$useContext2.leaveSettingsUser,
    organisationStatus = _React$useContext2.organisationStatus,
    teamId = _React$useContext2.teamId;

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);

  React.useEffect(function () {
    if ((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  var leaveSettingsCheckForUser = leaveSettingsUser && leaveSettingsUser !== null && leaveSettingsUser !== void 0 && leaveSettingsUser.approvedList.length ? leaveSettingsUser === null || leaveSettingsUser === void 0 ? void 0 : leaveSettingsUser.approvedList.find(function (o) {
    return o.userId === user.userId;
  }) : null;
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    holidayTypeCheck = _useState6[0],
    setHolidayTypeCheck = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    applyHolidayShow = _useState8[0],
    setApplyHolidayShow = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    editHolidayShow = _useState10[0],
    setEditHolidayShow = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    deleteHolidayShow = _useState12[0],
    setDeleteHolidayShow = _useState12[1];
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    importShow = _React$useState2[0],
    setImportButton = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isAllLoaded = _React$useState4[0],
    setIsAllLoaded = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isLoadingMore = _React$useState6[0],
    setIsLoadingMore = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isLoadMoreButton = _React$useState8[0],
    setIsLoadMoreButton = _React$useState8[1];
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    holidayViewShow = _useState14[0],
    setHolidayViewShow = _useState14[1];
  var handleApplyHolidayClose = function handleApplyHolidayClose() {
    return setApplyHolidayShow(false);
  };
  var handleApplyHolidayShow = function handleApplyHolidayShow() {
    return setApplyHolidayShow(true);
  };
  var handleEditHolidayClose = function handleEditHolidayClose() {
    return setEditHolidayShow(false);
  };
  var handleEditHolidayShow = function handleEditHolidayShow(list) {
    setEditHolidayShow(list);
  };
  var handleDeleteHolidayClose = function handleDeleteHolidayClose() {
    return setDeleteHolidayShow(null);
  };
  var handleDeleteHolidayShow = function handleDeleteHolidayShow(list) {
    setDeleteHolidayShow(list);
  };
  var loadPage = role === "Admin" || role === null;
  React.useEffect(function () {
    if (holidayYear != holidayYearQuery) {
      var holidayTemp = convertOrganisationTimezones(holidayYear, organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone);
      setHolidayYearQuery(holidayTemp);
    }
  }, [holidayYear]);
  function convertOrganisationTimezones(sD, tz) {
    // console.log({ sD });

    var startTime = moment(sD).format("YYYY-MM-DD HH:mm:ss");
    var currentSystemTimezone = moment.tz.guess();
    var currentSystemOffset = moment.tz(currentSystemTimezone).utcOffset();
    var zoneoffset = moment.tz(tz).utcOffset();

    // console.log({ startTime });
    // console.log({ currentSystemOffset, zoneoffset });

    if (zoneoffset >= 0) {
      startTime = moment(startTime).toDate();
      if (zoneoffset !== currentSystemOffset) {
        startTime = moment(startTime).add(zoneoffset, "minutes").toDate();
      }
    } else {
      zoneoffset = Math.abs(zoneoffset);
      startTime = moment(startTime).add(zoneoffset, "minutes").toDate();
    }

    // console.log({ startTime });

    var startTimeFullFormat = moment(startTime).format("YYYY");
    // console.log({ startTimeFullFormat });

    return startTimeFullFormat;
  }

  // console.log("\n\n\n");

  // console.log({ tzcovert: convertOrganisationTimezones(holidayYear, organisationSettings?.organisationTimezone) });

  // console.log("\n\n\n");

  var _useQuery = useQuery(HOLIDAY_LIST_QUERY, {
      variables: {
        organisationId: organisationId,
        holidayType: holidayTypeCheck && holidayTypeCheck.value ? holidayTypeCheck.value : null,
        startYear: holidayYearQuery,
        endYear: holidayYearQuery,
        limit: LIMIT,
        offset: 0
      }
    }),
    holidayListData = _useQuery.data,
    holidayListError = _useQuery.error,
    holidayListLoading = _useQuery.loading,
    fetchMore = _useQuery.fetchMore,
    holidayListRefetch = _useQuery.refetch;
  var _useQuery2 = useQuery(LAST_YEAR_HOLIDAY_QUERY, {
      variables: {
        organisationId: organisationId,
        year: moment(holidayYear).format("YYYY"),
        timeZone: organisationSettings.organisationTimezone
      }
    }),
    lastYearHolidayData = _useQuery2.data,
    lastYearHolidayError = _useQuery2.error,
    lastYearHolidayLoading = _useQuery2.loading,
    lastYearHolidayRefetch = _useQuery2.refetch;

  // if (!loadPage) {
  //   return <Redirect to="/" />;
  // }
  var _useMutation = useMutation(IMPORT_OLD_DATA_HOLIDAY_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    importOldHoliday = _useMutation2[0],
    addOldHolidayLoading = _useMutation2[1].loading;
  var _useMutation3 = useMutation(IMPORT_OLD_DATA_NO_HOLIDAY_MUTATION),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    importOldHolidayNo = _useMutation4[0],
    addOldNoHolidayLoading = _useMutation4[1].loading;
  React.useEffect(function () {
    holidayListRefetch === null || holidayListRefetch === void 0 ? void 0 : holidayListRefetch();
    lastYearHolidayRefetch === null || lastYearHolidayRefetch === void 0 ? void 0 : lastYearHolidayRefetch();
    setIsAllLoaded(false);
    offsets = 0;
  }, [holidayTypeCheck]);
  var handleOldImportData = React.useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(values, actions) {
      var holidayAddResponse;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return importOldHoliday({
              variables: {
                organisationId: organisationId,
                timeZone: organisationSettings.organisationTimezone,
                year: moment(holidayYear).format("YYYY")
              },
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: HOLIDAY_LIST_QUERY,
                variables: {
                  organisationId: organisationId,
                  holidayType: holidayTypeCheck && holidayTypeCheck.value ? holidayTypeCheck.value : null,
                  startYear: moment(holidayYear).format("YYYY"),
                  endYear: moment(holidayYear).format("YYYY"),
                  limit: LIMIT,
                  offset: 0
                }
              }, {
                query: LAST_YEAR_HOLIDAY_QUERY,
                variables: {
                  organisationId: organisationId,
                  year: moment(holidayYear).format("YYYY"),
                  timeZone: organisationSettings.organisationTimezone
                }
              }]
            });
          case 3:
            holidayAddResponse = _context.sent;
            if (!holidayAddResponse || !holidayAddResponse.data || holidayAddResponse.data.importOldHoliday == null) {
              toast.error("Error Occurred, Try again later!!!");
            } else if (!holidayAddResponse || !holidayAddResponse.data || holidayAddResponse.data.importOldHoliday == "holiday already added") {
              toast.success("Already imported all the holidays!");
            } else {
              toast.success("Holidays added successfully!");
            }
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            if (_context.t0.message.includes("holidays date already exist")) {
              //actions.setFieldError("date", "Holidays date already Exists");
            }
            //actions.setSubmitting(false);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(), [holidayYear, holidayTypeCheck]);
  var handleOldImportDataNo = React.useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(values, actions) {
      var holidayAddResponse;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return importOldHolidayNo({
              variables: {
                organisationId: organisationId,
                year: moment(holidayYear).format("YYYY")
              },
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: HOLIDAY_LIST_QUERY,
                variables: {
                  organisationId: organisationId,
                  holidayType: holidayTypeCheck && holidayTypeCheck.value ? holidayTypeCheck.value : null,
                  startYear: moment(holidayYear).format("YYYY"),
                  endYear: moment(holidayYear).format("YYYY"),
                  limit: LIMIT,
                  offset: 0
                }
              }, {
                query: LAST_YEAR_HOLIDAY_QUERY,
                variables: {
                  organisationId: organisationId,
                  year: moment(holidayYear).format("YYYY"),
                  timeZone: organisationSettings.organisationTimezone
                }
              }]
            });
          case 3:
            holidayAddResponse = _context2.sent;
            if (!holidayAddResponse || !holidayAddResponse.data || holidayAddResponse.data.importOldHolidayNo == null) {
              toast.error("Error Occurred, Try again later!!!");
            } else {
              //toast.success("Holidays added successfully!");
            }
            _context2.next = 10;
            break;
          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            if (_context2.t0.message.includes("holidays date already exist")) {
              //actions.setFieldError("date", "Holidays date already Exists");
            }
            //actions.setSubmitting(false);
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 7]]);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }(), [holidayYear, holidayTypeCheck]);
  var handleImportClose = function handleImportClose() {
    setImportButton(false);
  };
  var handleImportShow = function handleImportShow() {
    setImportButton(true);
  };
  var handleHolidayViewClose = function handleHolidayViewClose() {
    setHolidayViewShow(null);
  };
  var handleHolidayViewShow = function handleHolidayViewShow(list) {
    setHolidayViewShow(list);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "holiday-import-root"
  }, !organisationSettings.leaveManagementFeature && organisationSettings.leaveManagementFeature !== undefined ? /*#__PURE__*/React.createElement(LeaveManagementEnableFeature, {
    displayName: user === null || user === void 0 ? void 0 : user.displayName,
    history: props === null || props === void 0 ? void 0 : props.history,
    role: role
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, role == "Admin" || leaveSettingsCheckForUser && role != "Admin" ? /*#__PURE__*/React.createElement("div", {
    className: "holiday-import-root-header-section"
  }, " ", /*#__PURE__*/React.createElement("div", {
    className: "holiday-import-root-header-filter-section"
  }, /*#__PURE__*/React.createElement(DatePicker, {
    selected: holidayYear,
    onChange: function onChange(date) {
      return setHolidayYear(date);
    },
    showYearPicker: true,
    dateFormat: "yyyy"
    //yearItemNumber={9}
    ,
    className: "holiday-import-date-picker"
  }), /*#__PURE__*/React.createElement(Select, {
    value: holidayTypeCheck,
    onChange: function onChange(e) {
      return setHolidayTypeCheck(e);
    },
    options: holidayTypeFilter,
    isClearable: true,
    className: "holiday-import-root-header-filter-type-select",
    classNamePrefix: "Filter By User",
    placeholder: "Select Holiday Type",
    components: {
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      }
    },
    theme: function theme(_theme) {
      return _objectSpread(_objectSpread({}, _theme), {}, {
        colors: _objectSpread(_objectSpread({}, _theme.colors), {}, {
          neutral50: "hsl(0deg 0% 50% / 42%)" // Placeholder color
        })
      });
    }
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleApplyHolidayShow();
    },
    className: "holiday-list-filter-download-icon-btn"
  }, "+ Add Holiday"), /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    onClick: function onClick() {
      handleImportShow();
    },
    className: "holiday-list-filter-upload-icon-btn"
  }, /*#__PURE__*/React.createElement(HiUpload, {
    className: "holiday-list-filter-upload-icon-import"
  }), " Import Holiday"))) : null, /*#__PURE__*/React.createElement(HolidayList, {
    columns: columns,
    handleEditHolidayShow: handleEditHolidayShow,
    handleDeleteHolidayShow: handleDeleteHolidayShow,
    holidayListData: holidayListData,
    holidayListError: holidayListError,
    holidayListLoading: holidayListLoading,
    fetchMore: fetchMore,
    role: role,
    leaveSettingsCheckForUser: leaveSettingsCheckForUser,
    holidayYear: holidayYear,
    handleOldImportData: handleOldImportData,
    addOldHolidayLoading: addOldHolidayLoading,
    handleOldImportDataNo: handleOldImportDataNo,
    addOldNoHolidayLoading: addOldNoHolidayLoading,
    lastYearHolidayData: lastYearHolidayData,
    holidayTypeCheck: holidayTypeCheck,
    isAllLoaded: isAllLoaded,
    setIsAllLoaded: setIsAllLoaded,
    isLoadingMore: isLoadingMore,
    setIsLoadingMore: setIsLoadingMore,
    isLoadMoreButton: isLoadMoreButton,
    setIsLoadMoreButton: setIsLoadMoreButton,
    handleHolidayViewShow: handleHolidayViewShow
  })), /*#__PURE__*/React.createElement(AddHolidayModal, {
    applyHolidayShow: applyHolidayShow,
    handleApplyHolidayClose: handleApplyHolidayClose,
    organisationId: organisationId,
    organisationSettings: organisationSettings,
    holidayTypeCheck: holidayTypeCheck,
    holidayYear: holidayYear,
    handleOldImportData: handleOldImportData,
    role: role,
    addOldHolidayLoading: addOldHolidayLoading,
    handleOldImportDataNo: handleOldImportDataNo,
    addOldNoHolidayLoading: addOldNoHolidayLoading,
    lastYearHolidayData: lastYearHolidayData,
    timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    teamId: teamId
  }), /*#__PURE__*/React.createElement(EditHolidayModal, {
    editHolidayShow: editHolidayShow,
    handleEditHolidayClose: handleEditHolidayClose,
    organisationSettings: organisationSettings,
    organisationId: organisationId,
    holidayTypeCheck: holidayTypeCheck,
    holidayYear: holidayYear,
    timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    teamId: teamId
  }), /*#__PURE__*/React.createElement(DeleteHolidayModal, {
    organisationId: organisationId,
    deleteHolidayShow: deleteHolidayShow,
    handleDeleteHolidayClose: handleDeleteHolidayClose,
    holidayTypeCheck: holidayTypeCheck,
    holidayYear: holidayYear
  }), /*#__PURE__*/React.createElement(ImportModal, {
    importShow: importShow,
    setImportButton: setImportButton,
    handleImportClose: handleImportClose,
    organisationId: organisationId,
    timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    holidayYear: holidayYear,
    handleOldImportData: handleOldImportData,
    role: role,
    addOldHolidayLoading: addOldHolidayLoading,
    handleOldImportDataNo: handleOldImportDataNo,
    addOldNoHolidayLoading: addOldNoHolidayLoading,
    lastYearHolidayData: lastYearHolidayData
  }), /*#__PURE__*/React.createElement(ViewDetailsModal, {
    holidayViewShow: holidayViewShow,
    handleHolidayViewClose: handleHolidayViewClose
  }));
};
var columns = [{
  Header: "S.No",
  accessor: "sno"
}, {
  Header: "Holiday Title",
  accessor: "holidayName"
}, {
  Header: "Holiday Date",
  accessor: "date"
}, {
  Header: "Day",
  accessor: "day"
}, {
  Header: "Session",
  accessor: "dayType"
}, {
  Header: "Holiday Type",
  accessor: "holidayType"
}, {
  Header: "Visibility",
  accessor: "holidayVisibility"
}, {
  Header: "",
  accessor: "action"
}];
var HolidayList = function HolidayList(props) {
  var _holidayListData$holi, _holidayListData$holi2, _holidayListData$holi3, _holidayListData$holi4, _holidayListData$holi5, _holidayListData$holi6, _holidayListData$holi7, _holidayListData$holi8, _holidayListData$holi9, _holidayListData$holi10, _holidayListData$holi11, _lastYearHolidayData$, _lastYearHolidayData$2, _holidayListData$holi12, _holidayListData$holi13;
  var columns = props.columns,
    handleEditHolidayShow = props.handleEditHolidayShow,
    handleDeleteHolidayShow = props.handleDeleteHolidayShow,
    holidayListData = props.holidayListData,
    holidayListError = props.holidayListError,
    holidayListLoading = props.holidayListLoading,
    fetchMore = props.fetchMore,
    role = props.role,
    leaveSettingsCheckForUser = props.leaveSettingsCheckForUser,
    holidayYear = props.holidayYear,
    handleOldImportData = props.handleOldImportData,
    addOldHolidayLoading = props.addOldHolidayLoading,
    handleOldImportDataNo = props.handleOldImportDataNo,
    addOldNoHolidayLoading = props.addOldNoHolidayLoading,
    lastYearHolidayData = props.lastYearHolidayData,
    holidayTypeCheck = props.holidayTypeCheck,
    isAllLoaded = props.isAllLoaded,
    setIsAllLoaded = props.setIsAllLoaded,
    isLoadingMore = props.isLoadingMore,
    setIsLoadingMore = props.setIsLoadingMore,
    isLoadMoreButton = props.isLoadMoreButton,
    setIsLoadMoreButton = props.setIsLoadMoreButton,
    handleHolidayViewShow = props.handleHolidayViewShow;
  if (holidayListLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (holidayListError) {
    return /*#__PURE__*/React.createElement("div", {
      className: "common-err-refresh-text"
    }, "Something went wrong, please refresh the page.");
  }
  if (!holidayListData) {
    return null;
  }
  if ((holidayListData === null || holidayListData === void 0 ? void 0 : (_holidayListData$holi = holidayListData.holidayList) === null || _holidayListData$holi === void 0 ? void 0 : (_holidayListData$holi2 = _holidayListData$holi.holidayData) === null || _holidayListData$holi2 === void 0 ? void 0 : _holidayListData$holi2.length) !== 0 && (holidayListData === null || holidayListData === void 0 ? void 0 : (_holidayListData$holi3 = holidayListData.holidayList) === null || _holidayListData$holi3 === void 0 ? void 0 : (_holidayListData$holi4 = _holidayListData$holi3.holidayData) === null || _holidayListData$holi4 === void 0 ? void 0 : _holidayListData$holi4.length) < LIMIT && !isAllLoaded) {
    setIsAllLoaded(true);
  }
  var handleLoadMore = function handleLoadMore() {
    if (holidayListLoading) return;
    setIsLoadingMore(true);
    offsets = offsets + 1;
    fetchMore({
      variables: {
        offset: offsets * LIMIT
      },
      updateQuery: function updateQuery(prev, _ref3) {
        var _fetchMoreResult$holi, _fetchMoreResult$holi2, _fetchMoreResult$holi3;
        var fetchMoreResult = _ref3.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$holi = fetchMoreResult.holidayList) === null || _fetchMoreResult$holi === void 0 ? void 0 : _fetchMoreResult$holi.holidayData.length) === 0 && (fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$holi2 = fetchMoreResult.holidayList) === null || _fetchMoreResult$holi2 === void 0 ? void 0 : _fetchMoreResult$holi2.holidayData.length) < LIMIT && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        setIsLoadingMore(false);
        var NewFilterData = [];
        fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$holi3 = fetchMoreResult.holidayList) === null || _fetchMoreResult$holi3 === void 0 ? void 0 : _fetchMoreResult$holi3.holidayData.forEach(function (newHoliday) {
          var _prev$holidayList;
          var found = prev === null || prev === void 0 ? void 0 : (_prev$holidayList = prev.holidayList) === null || _prev$holidayList === void 0 ? void 0 : _prev$holidayList.holidayData.find(function (item) {
            return item.holidayId === newHoliday.holidayId;
          });
          if (!found) {
            // If not found, add validation.
            NewFilterData.push(newHoliday);
          }
        });
        return _objectSpread(_objectSpread({}, prev), {}, {
          // holidayList: [...prev.holidayList, ...NewFilterData],
          holidayList: _objectSpread(_objectSpread({}, prev.holidayList), {}, {
            holidayData: [].concat(_toConsumableArray(prev.holidayList.holidayData), NewFilterData)
          })
        });
      }
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "holiday-list-table-content-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "holiday-list-content"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "holiday-list-content-new"
  }, holidayListData !== null && holidayListData !== void 0 && (_holidayListData$holi5 = holidayListData.holidayList) !== null && _holidayListData$holi5 !== void 0 && (_holidayListData$holi6 = _holidayListData$holi5.holidayData) !== null && _holidayListData$holi6 !== void 0 && _holidayListData$holi6.length ? /*#__PURE__*/React.createElement("table", {
    className: "holiday-list-table",
    borderless: true,
    striped: true
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, columns.map(function (column) {
    if (role == "Admin" || leaveSettingsCheckForUser && role != "Admin" || role != "Admin" && column.accessor != "action") {
      return /*#__PURE__*/React.createElement("th", {
        className: "holiday-list-report-react-table-thead"
      }, column.Header);
    }
  }))), /*#__PURE__*/React.createElement("tbody", null, holidayListData === null || holidayListData === void 0 ? void 0 : (_holidayListData$holi7 = holidayListData.holidayList) === null || _holidayListData$holi7 === void 0 ? void 0 : (_holidayListData$holi8 = _holidayListData$holi7.holidayData) === null || _holidayListData$holi8 === void 0 ? void 0 : _holidayListData$holi8.map(function (row, i) {
    var holidayId = row.holidayId,
      title = row.title,
      date = row.date,
      session = row.session,
      type = row.type,
      dateFormat = row.dateFormat,
      day = row.day,
      holidayVisibility = row.holidayVisibility,
      leaveUser = row.leaveUser;
    return /*#__PURE__*/React.createElement("tr", {
      className: "holiday-list-table-tbody-tr"
    }, /*#__PURE__*/React.createElement("td", null, i + 1), /*#__PURE__*/React.createElement("td", {
      className: "holiday-list-table-cursor",
      onClick: function onClick() {
        return handleHolidayViewShow(_objectSpread({}, row));
      }
    }, title), /*#__PURE__*/React.createElement("td", {
      className: "holiday-list-table-cursor",
      onClick: function onClick() {
        return handleHolidayViewShow(_objectSpread({}, row));
      }
    }, dateFormat), /*#__PURE__*/React.createElement("td", {
      className: "holiday-list-table-cursor",
      onClick: function onClick() {
        return handleHolidayViewShow(_objectSpread({}, row));
      }
    }, day), /*#__PURE__*/React.createElement("td", {
      className: "holiday-list-table-cursor",
      onClick: function onClick() {
        return handleHolidayViewShow(_objectSpread({}, row));
      }
    }, session == "full-day" ? "Full Day" : session == "half-day-first-half" ? "Half Day - 1st Half" : "Half Day - 2nd Half"), /*#__PURE__*/React.createElement("td", {
      className: "holiday-list-table-cursor",
      onClick: function onClick() {
        return handleHolidayViewShow(_objectSpread({}, row));
      }
    }, type == "public-holiday" ? "Public Holiday" : type == "office-holiday" ? "Office Holiday" : "Floater Holiday"), /*#__PURE__*/React.createElement("td", {
      className: "holiday-list-table-cursor",
      onClick: function onClick() {
        return handleHolidayViewShow(_objectSpread({}, row));
      }
    }, holidayVisibility == "private" ? "Selected Members" : " All Employees"), role == "Admin" || leaveSettingsCheckForUser && role != "Admin" ? /*#__PURE__*/React.createElement("td", null, " ", /*#__PURE__*/React.createElement("div", {
      className: "holiday-list-edit-profile-text-td"
    }, /*#__PURE__*/React.createElement("div", {
      className: "holiday-list-edit-profile-text-td-table-data-icon-div",
      onClick: function onClick() {
        return handleHolidayViewShow(_objectSpread({}, row));
      }
    }, /*#__PURE__*/React.createElement(BsEyeFill, {
      className: "holiday-list-edit-profile-text-td-data-edit-icon"
    }), /*#__PURE__*/React.createElement("p", {
      className: "holiday-list-edit-profile-text-td-edit-text"
    }, "View")), /*#__PURE__*/React.createElement("div", {
      className: "holiday-list-edit-profile-text-td-table-data-icon-div",
      onClick: function onClick() {
        return handleEditHolidayShow({
          holidayId: holidayId,
          title: title,
          date: date,
          session: session,
          type: type,
          holidayVisibility: holidayVisibility,
          leaveUser: leaveUser
        });
      }
    }, /*#__PURE__*/React.createElement(MdModeEdit, {
      className: "holiday-list-edit-profile-text-td-data-edit-icon"
    }), /*#__PURE__*/React.createElement("p", {
      className: "holiday-list-edit-profile-text-td-edit-text"
    }, "Edit")), /*#__PURE__*/React.createElement("div", {
      className: "holiday-list-edit-profile-text-td-table-data-icon-div",
      onClick: function onClick() {
        return handleDeleteHolidayShow(holidayId);
      }
    }, /*#__PURE__*/React.createElement(MdDeleteForever, {
      className: "holiday-list-edit-profile-text-td-data-edit-icon"
    }), /*#__PURE__*/React.createElement("p", {
      className: "holiday-list-edit-profile-text-td-edit-text"
    }, "Delete")))) : null);
  }))) : role == "Member" && !(holidayListData !== null && holidayListData !== void 0 && (_holidayListData$holi9 = holidayListData.holidayList) !== null && _holidayListData$holi9 !== void 0 && (_holidayListData$holi10 = _holidayListData$holi9.holidayData) !== null && _holidayListData$holi10 !== void 0 && _holidayListData$holi10.length) ? /*#__PURE__*/React.createElement("div", {
    className: "holiday-list-no-data-text"
  }, "Your admin yet to add a holiday for ", moment(holidayYear).format("YYYY"), "!", " ") : /*#__PURE__*/React.createElement(React.Fragment, null, (holidayListData === null || holidayListData === void 0 ? void 0 : (_holidayListData$holi11 = holidayListData.holidayList) === null || _holidayListData$holi11 === void 0 ? void 0 : _holidayListData$holi11.holidayCount) == 0 && lastYearHolidayData !== null && lastYearHolidayData !== void 0 && lastYearHolidayData.importOldHolidayList && (lastYearHolidayData === null || lastYearHolidayData === void 0 ? void 0 : (_lastYearHolidayData$ = lastYearHolidayData.importOldHolidayList) === null || _lastYearHolidayData$ === void 0 ? void 0 : _lastYearHolidayData$.year) == "" && (lastYearHolidayData === null || lastYearHolidayData === void 0 ? void 0 : (_lastYearHolidayData$2 = lastYearHolidayData.importOldHolidayList) === null || _lastYearHolidayData$2 === void 0 ? void 0 : _lastYearHolidayData$2.lastYear) == "true" ? /*#__PURE__*/React.createElement("div", {
    className: "holiday-list-import-old-data-text-div"
  }, "Do you want to import last year's holidays?", /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    className: "holiday-list-import-old-data-text-span-yes",
    onClick: function onClick() {
      handleOldImportData();
    }
  }, addOldHolidayLoading ? "Loading" : "Yes"), /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    className: "holiday-list-import-old-data-text-span-no",
    onClick: function onClick() {
      handleOldImportDataNo();
    }
  }, addOldNoHolidayLoading ? "Loading" : "No"))) : null, /*#__PURE__*/React.createElement("div", {
    className: "holiday-list-no-data-text"
  }, holidayTypeCheck && holidayTypeCheck.label ? "You are yet to add your first ".concat(holidayTypeCheck && holidayTypeCheck.label ? holidayTypeCheck.label : "", "!") : "You are yet to add your first holiday for ".concat(moment(holidayYear).format("YYYY"), "!"))), holidayListData !== null && holidayListData !== void 0 && (_holidayListData$holi12 = holidayListData.holidayList) !== null && _holidayListData$holi12 !== void 0 && (_holidayListData$holi13 = _holidayListData$holi12.holidayData) !== null && _holidayListData$holi13 !== void 0 && _holidayListData$holi13.length ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, !isAllLoaded ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMore && !isLoadMoreButton ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMore();
    }
  }, "Load more")) : /*#__PURE__*/React.createElement("p", {
    className: "project-task-tracket-all-task-label"
  }, "You have seen all the holidays")) : null)));
};
function convertOrganisationTimezone(_x5, _x6) {
  return _convertOrganisationTimezone.apply(this, arguments);
}
function _convertOrganisationTimezone() {
  _convertOrganisationTimezone = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(sD, tz) {
    var currentSystemTimezone, startTime, currentSystemOffset, zoneoffset, zoneoffsetTemp, currentSystemOffsetTemp, startLoopingDate;
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          currentSystemTimezone = moment.tz.guess();
          startTime = moment(sD).tz(currentSystemTimezone).format("YYYY-MM-DD");
          currentSystemOffset = moment.tz(currentSystemTimezone).utcOffset();
          zoneoffset = moment.tz(tz).utcOffset();
          if (zoneoffset !== currentSystemOffset) {
            zoneoffsetTemp = Math.abs(zoneoffset);
            currentSystemOffsetTemp = Math.abs(currentSystemOffset);
            if (zoneoffset > 0) {
              zoneoffset = zoneoffsetTemp - currentSystemOffsetTemp;
            } else {
              zoneoffset = zoneoffsetTemp + currentSystemOffsetTemp;
            }
          }
          startLoopingDate = moment(startTime).tz(currentSystemTimezone).format("YYYY-MM-DD");
          if (zoneoffset >= 0) {
            startLoopingDate = moment(startTime).format("YYYY-MM-DD");
            if (zoneoffset !== currentSystemOffset && zoneoffset < currentSystemOffset) {
              startLoopingDate = moment(startTime).add(zoneoffset, "minutes").format("YYYY-MM-DD");
            }
          } else {
            zoneoffset = Math.abs(zoneoffset);
            startLoopingDate = moment(startTime).add(zoneoffset, "minutes").format("YYYY-MM-DD");
          }
          return _context9.abrupt("return", startLoopingDate);
        case 8:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return _convertOrganisationTimezone.apply(this, arguments);
}
var AddHolidayModal = function AddHolidayModal(props) {
  var _lastYearHolidayData$3, _lastYearHolidayData$4, _userWithSearch, _userWithSearch2;
  var applyHolidayShow = props.applyHolidayShow,
    handleApplyHolidayClose = props.handleApplyHolidayClose,
    organisationId = props.organisationId,
    organisationSettings = props.organisationSettings,
    holidayTypeCheck = props.holidayTypeCheck,
    holidayYear = props.holidayYear,
    handleOldImportData = props.handleOldImportData,
    role = props.role,
    addOldHolidayLoading = props.addOldHolidayLoading,
    handleOldImportDataNo = props.handleOldImportDataNo,
    addOldNoHolidayLoading = props.addOldNoHolidayLoading,
    lastYearHolidayData = props.lastYearHolidayData,
    timeZone = props.timeZone,
    teamId = props.teamId;
  if (applyHolidayShow == null) {
    return false;
  }
  var _useState15 = useState(new Date()),
    _useState16 = _slicedToArray(_useState15, 2),
    startDate = _useState16[0],
    setStartDate = _useState16[1];
  var _React$useState9 = React.useState(true),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isPriorityCheck = _React$useState10[0],
    setIsPriorityCheck = _React$useState10[1];
  var _React$useState11 = React.useState([]),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    userActive = _React$useState12[0],
    setUserActive = _React$useState12[1];
  var _React$useState13 = React.useState(""),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    searchUser = _React$useState14[0],
    setSearchUser = _React$useState14[1];
  var _React$useState15 = React.useState(true),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    isUserSelected = _React$useState16[0],
    setUserSelected = _React$useState16[1];
  var _React$useState17 = React.useState("false"),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    isUserNavCheck = _React$useState18[0],
    setIsUserNavCheck = _React$useState18[1];
  var _React$useState19 = React.useState(null),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    holidayId = _React$useState20[0],
    setHolidayId = _React$useState20[1];
  var _React$useState21 = React.useState([]),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    data = _React$useState22[0],
    setData = _React$useState22[1];

  // Server-side rejection, shown under the Add Holiday button.
  var _React$useState23 = React.useState(null),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    holidaySubmitError = _React$useState24[0],
    setHolidaySubmitError = _React$useState24[1];
  var _useQuery3 = useQuery(GET_USER_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userRole: role
      },
      skip: !organisationId
    }),
    usersLoading = _useQuery3.loading,
    usersData = _useQuery3.data,
    usersError = _useQuery3.error,
    userListRefetch = _useQuery3.refetch;
  React.useEffect(function () {
    if (usersData !== null && usersData !== void 0 && usersData.getUserListing) {
      var _usersData$getUserLis;
      var selectedUserIds = usersData === null || usersData === void 0 ? void 0 : (_usersData$getUserLis = usersData.getUserListing) === null || _usersData$getUserLis === void 0 ? void 0 : _usersData$getUserLis.map(function (team) {
        return team.userId;
      });
      setUserActive(selectedUserIds);
    }
  }, [usersData]);
  var _useMutation5 = useMutation(ADD_HOLIDAY_MUTATION),
    _useMutation6 = _slicedToArray(_useMutation5, 2),
    addHoliday = _useMutation6[0],
    addHolidayLoading = _useMutation6[1].loading;
  var _useMutation7 = useMutation(ADD_USER_HOLIDAY_MUTATION),
    _useMutation8 = _slicedToArray(_useMutation7, 2),
    addUserHolidayList = _useMutation8[0],
    addUserHolidayLoading = _useMutation8[1].loading;
  var handleSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(values, actions) {
      var holidayTitle, date, holidaySession, holidayType, dateTemp, holidayAddResponse, _holidayAddResponse$e, _holidayAddResponse$e2, _error$graphQLErrors, _error$graphQLErrors$;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            holidayTitle = values.holidayTitle, date = values.date, holidaySession = values.holidaySession, holidayType = values.holidayType;
            setHolidaySubmitError(null);
            _context3.next = 4;
            return convertOrganisationTimezone(date, timeZone);
          case 4:
            dateTemp = _context3.sent;
            _context3.prev = 5;
            _context3.next = 8;
            return addHoliday({
              variables: {
                organisationId: organisationId,
                holidayTitle: holidayTitle,
                date: dateTemp,
                session: holidaySession,
                holidayType: holidayType,
                timeZone: organisationSettings.organisationTimezone,
                holidayVisibility: isPriorityCheck ? "public" : "private"
              },
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: HOLIDAY_LIST_QUERY,
                variables: {
                  organisationId: organisationId,
                  holidayType: holidayTypeCheck && holidayTypeCheck.value ? holidayTypeCheck.value : null,
                  startYear: moment(holidayYear).format("YYYY"),
                  endYear: moment(holidayYear).format("YYYY"),
                  limit: LIMIT,
                  offset: 0
                }
              }, {
                query: LAST_YEAR_HOLIDAY_QUERY,
                variables: {
                  organisationId: organisationId,
                  year: moment(holidayYear).format("YYYY"),
                  timeZone: organisationSettings.organisationTimezone
                }
              }]
            });
          case 8:
            holidayAddResponse = _context3.sent;
            // Resets form after submission is complete
            actions.resetForm();
            actions.setSubmitting(false);
            if (!holidayAddResponse || !holidayAddResponse.data || holidayAddResponse.data.addHoliday == null) {
              setHolidaySubmitError((holidayAddResponse === null || holidayAddResponse === void 0 ? void 0 : (_holidayAddResponse$e = holidayAddResponse.errors) === null || _holidayAddResponse$e === void 0 ? void 0 : (_holidayAddResponse$e2 = _holidayAddResponse$e[0]) === null || _holidayAddResponse$e2 === void 0 ? void 0 : _holidayAddResponse$e2.message) || "Error Occurred, Try again later!!!");
            } else {
              // setTeamActive
              setHolidayId(holidayAddResponse.data.addHoliday);
              if (!isPriorityCheck) {
                setData([{
                  holidayTitle: holidayTitle,
                  date: date,
                  holidaySession: holidaySession,
                  holidayType: holidayType
                }]);
                setIsUserNavCheck(true);
              }
              if (isPriorityCheck) {
                toast.success("Holiday added successfully!");
                setIsUserNavCheck("false");
                handleApplyHolidayClose();
              }
            }
            _context3.next = 18;
            break;
          case 14:
            _context3.prev = 14;
            _context3.t0 = _context3["catch"](5);
            if (_context3.t0.message.includes("holiday date already exist")) {
              actions.setFieldError("date", "Holiday date already Exists");
            } else {
              // Show the server's own message (e.g. "Maximum holiday limit
              // reached") under the button. Anything else was silently swallowed
              // here, so the user saw nothing at all.
              setHolidaySubmitError((_context3.t0 === null || _context3.t0 === void 0 ? void 0 : (_error$graphQLErrors = _context3.t0.graphQLErrors) === null || _error$graphQLErrors === void 0 ? void 0 : (_error$graphQLErrors$ = _error$graphQLErrors[0]) === null || _error$graphQLErrors$ === void 0 ? void 0 : _error$graphQLErrors$.message) || "Error Occurred, Try again later!!!");
            }
            actions.setSubmitting(false);
          case 18:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[5, 14]]);
    }));
    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }(), [isPriorityCheck, holidayId, isUserNavCheck, userActive]);
  var handleUserSubmitButton = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var dateTemp, holidayAddResponse;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return convertOrganisationTimezone(data[0].date, timeZone);
        case 2:
          dateTemp = _context4.sent;
          _context4.prev = 3;
          _context4.next = 6;
          return addUserHolidayList({
            variables: {
              organisationId: organisationId,
              holidayId: holidayId,
              userId: userActive,
              date: dateTemp,
              session: data[0].holidaySession,
              timeZone: organisationSettings.organisationTimezone
            },
            awaitRefetchQueries: true,
            refetchQueries: [{
              query: HOLIDAY_LIST_QUERY,
              variables: {
                organisationId: organisationId,
                holidayType: holidayTypeCheck && holidayTypeCheck.value ? holidayTypeCheck.value : null,
                startYear: moment(holidayYear).format("YYYY"),
                endYear: moment(holidayYear).format("YYYY"),
                limit: LIMIT,
                offset: 0
              }
            }, {
              query: LAST_YEAR_HOLIDAY_QUERY,
              variables: {
                organisationId: organisationId,
                year: moment(holidayYear).format("YYYY"),
                timeZone: organisationSettings.organisationTimezone
              }
            }]
          });
        case 6:
          holidayAddResponse = _context4.sent;
          if (!holidayAddResponse || !holidayAddResponse.data || holidayAddResponse.data.addUserHolidayList == false) {
            toast.error("Error Occurred, Try again later!!!");
          } else {
            toast.success("Holiday added successfully!");
            setIsUserNavCheck("false");
            handleApplyHolidayClose();
          }
          _context4.next = 13;
          break;
        case 10:
          _context4.prev = 10;
          _context4.t0 = _context4["catch"](3);
          toast.error("Error Occurred, Try again later!!!");
        case 13:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[3, 10]]);
  })), [isPriorityCheck, holidayId, isUserNavCheck, userActive, data]);
  var userDetails = !usersLoading && !usersError ? usersData === null || usersData === void 0 ? void 0 : usersData.getUserListing : null;
  var userIds = userDetails === null || userDetails === void 0 ? void 0 : userDetails.map(function (user) {
    return user.userId;
  });
  useEffect(function () {
    if (applyHolidayShow) {
      setStartDate(new Date());
      setHolidaySubmitError(null);
    }
  }, [applyHolidayShow]);
  var handleKey = function handleKey(data) {
    setIsPriorityCheck(function (prev) {
      return prev === true ? false : true;
    });
  };
  var userWithSearch = function userWithSearch(userData) {
    if (!searchUser) {
      return userData;
    }
    return userData.filter(function (filterUsersData) {
      var _filterUsersData$disp, _filterUsersData$disp2, _filterUsersData$disp3, _filterUsersData$disp4;
      return filterUsersData === null || filterUsersData === void 0 ? void 0 : (_filterUsersData$disp = filterUsersData.displayName) === null || _filterUsersData$disp === void 0 ? void 0 : (_filterUsersData$disp2 = _filterUsersData$disp.toLowerCase) === null || _filterUsersData$disp2 === void 0 ? void 0 : (_filterUsersData$disp3 = _filterUsersData$disp2.call(_filterUsersData$disp)) === null || _filterUsersData$disp3 === void 0 ? void 0 : (_filterUsersData$disp4 = _filterUsersData$disp3.includes) === null || _filterUsersData$disp4 === void 0 ? void 0 : _filterUsersData$disp4.call(_filterUsersData$disp3, searchUser.toLowerCase());
    });
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: applyHolidayShow,
    onHide: handleApplyHolidayClose,
    animation: false,
    size: "md",
    className: "add-holiday-import-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "add-holiday-import-modal-header-title"
  }, "Add Holiday")), role !== "Member" ? /*#__PURE__*/React.createElement(React.Fragment, null, lastYearHolidayData !== null && lastYearHolidayData !== void 0 && lastYearHolidayData.importOldHolidayList && (lastYearHolidayData === null || lastYearHolidayData === void 0 ? void 0 : (_lastYearHolidayData$3 = lastYearHolidayData.importOldHolidayList) === null || _lastYearHolidayData$3 === void 0 ? void 0 : _lastYearHolidayData$3.year) == "" && (lastYearHolidayData === null || lastYearHolidayData === void 0 ? void 0 : (_lastYearHolidayData$4 = lastYearHolidayData.importOldHolidayList) === null || _lastYearHolidayData$4 === void 0 ? void 0 : _lastYearHolidayData$4.lastYear) == "true" ? /*#__PURE__*/React.createElement("div", {
    className: "holiday-list-import-old-data-text-div-add"
  }, /*#__PURE__*/React.createElement(FaRegLightbulb, {
    className: "holiday-list-import-old-data-text-span-icon"
  }), " Do you want to import last year's holidays?", " ", /*#__PURE__*/React.createElement("span", {
    className: "holiday-list-import-old-data-text-span",
    onClick: function onClick() {
      handleOldImportData();
    }
  }, addOldHolidayLoading ? "Loading" : "Yes"), " ", "or", " ", /*#__PURE__*/React.createElement("span", {
    className: "holiday-list-import-old-data-text-span",
    onClick: function onClick() {
      handleOldImportDataNo();
    }
  }, addOldNoHolidayLoading ? "Loading" : "No")) : null) : null, /*#__PURE__*/React.createElement(Modal.Body, {
    className: "add-holiday-import-modal-body"
  }, isUserNavCheck == "false" ? /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      date: new Date(),
      holidayTitle: "",
      holidaySession: "full-day",
      holidayType: "public-holiday"
    },
    validationSchema: AddHolidaySchema,
    onSubmit: handleSubmit
  }, function (_ref6) {
    var setFieldValue = _ref6.setFieldValue,
      errors = _ref6.errors,
      touched = _ref6.touched,
      values = _ref6.values;
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement("div", {
      className: "add-holiday-import-modal-body-wrapper-form"
    }, /*#__PURE__*/React.createElement("div", {
      className: "add-holiday-import-modal-body-wrapper-form-div"
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, " ", /*#__PURE__*/React.createElement(Field, {
      name: "date"
    }, function (_ref7) {
      var field = _ref7.field,
        form = _ref7.form;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "add-holiday-import-modal-body-wrapper-form-div-field-form-group"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "add-holiday-import-modal-body-wrapper-form-div-field-label-name"
      }, "Holiday Date"), errors.date && touched.date ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error add-holiday-import-modal-body-input-form-error"
      }, errors.date) : null), /*#__PURE__*/React.createElement(DatePicker, {
        selected: startDate,
        onChange: function onChange(date) {
          setStartDate(date);
          setFieldValue("date", date);
        },
        className: "holiday-import-add-modal-body-wrapper-form-input",
        dateFormat: "dd MMM, yyyy"
      }));
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Field, {
      name: "holidayTitle"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "add-holiday-import-modal-body-wrapper-form-div-group"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "add-holiday-import-modal-body-wrapper-form-div-field-label-name"
      }, "Holiday Title"), errors.holidayTitle && touched.holidayTitle ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error add-holiday-import-modal-body-input-form-error"
      }, errors.holidayTitle) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        type: "text",
        placeholder: "Enter Holiday Title",
        className: "holiday-import-add-modal-body-wrapper-form-input"
      }, field)));
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, " ", /*#__PURE__*/React.createElement(Field, {
      name: "holidaySession"
    }, function (_ref8) {
      var field = _ref8.field,
        form = _ref8.form;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "add-holiday-import-modal-body-wrapper-form-div-group"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "add-holiday-import-modal-body-wrapper-form-div-field-label-name"
      }, "Holiday Session"), errors.holidaySession && touched.holidaySession ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error add-holiday-import-modal-body-input-form-error"
      }, errors.holidaySession) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        as: "select"
        //  value={values.user}
        ,
        className: "add-holiday-import-modal-body-wrapper-form-div-field-input"
      }, field), /*#__PURE__*/React.createElement("option", {
        key: "select-user",
        value: " "
      }, "Select Holiday Session"), dayTypeList.map(function (key, index) {
        return /*#__PURE__*/React.createElement("option", {
          key: key.value,
          value: key.value
        }, key.name);
      })));
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, " ", /*#__PURE__*/React.createElement(Field, {
      name: "holidayType"
    }, function (_ref9) {
      var field = _ref9.field,
        form = _ref9.form;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "add-holiday-import-modal-body-wrapper-form-div-group"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "add-holiday-import-modal-body-wrapper-form-div-field-label-name"
      }, "Holiday Type"), errors.holidayType && touched.holidayType ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error add-holiday-import-modal-body-input-form-error"
      }, errors.holidayType) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        as: "select"
        //  value={values.user}
        ,
        className: "add-holiday-import-modal-body-wrapper-form-div-field-input"
      }, field), /*#__PURE__*/React.createElement("option", {
        key: "select-user",
        value: " "
      }, "Select Holiday Type"), holidayTypeList.map(function (key, index) {
        return /*#__PURE__*/React.createElement("option", {
          key: key.value,
          value: key.value
        }, key.name);
      })));
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: "leave-setting-accordion"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "leave-setting-project-tasks-modal-content-header-setting"
    }, /*#__PURE__*/React.createElement(HiLockClosed, {
      className: "project-tasks-modal-content-header-setting-icon"
    }), " Assign this holiday to all members"), /*#__PURE__*/React.createElement("div", {
      className: "leave-setting-task-modal-private-toggle-div-command-line"
    }, "You can assign the selective members to this holiday by unselecting this option")), /*#__PURE__*/React.createElement("div", {
      className: "tasks-rule-uparrow toggle-switch",
      onClick: function onClick() {
        return handleKey("private");
      }
    }, /*#__PURE__*/React.createElement("label", {
      "for": "chkTest"
    }, /*#__PURE__*/React.createElement("span", {
      className: classNames("toggle-track", {
        "toggle-track-nav-right-div": isPriorityCheck
      })
    })))))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, " ", /*#__PURE__*/React.createElement("div", {
      className: "add-holiday-import-footer-add-holiday-import-button"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      className: "add-holiday-import-footer-add-holiday-add-button",
      type: "submit",
      disabled: addHolidayLoading ? true : false
    }, addHolidayLoading ? "Loading..." : "Add Holiday"), /*#__PURE__*/React.createElement(Button, {
      variant: "outline-secondary",
      className: "add-holiday-import-footer-add-holiday-cancel-button"
      // type="close"
      ,
      onClick: function onClick() {
        return handleApplyHolidayClose();
      }
    }, "Cancel")), holidaySubmitError ? /*#__PURE__*/React.createElement("div", {
      className: "add-holiday-import-footer-submit-error"
    }, holidaySubmitError) : null)))))));
  }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "project-task-acc-collapse-whole-div-data"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "tasks-modal-content-person-name"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tasks-modal-content-person-name-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-modal-content-person-name-header-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-modal-content-person-name-header-section-content w-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-task-modals-searchbox-wrapper"
  }, /*#__PURE__*/React.createElement(SearchBar, {
    value: searchUser,
    onChange: setSearchUser,
    placeholder: "Search employee name"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "project-task-modals-user-label-section-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-setting-project-task-modals-user-label-section"
  }, "Employee Names"), (userActive === null || userActive === void 0 ? void 0 : userActive.length) == (userIds === null || userIds === void 0 ? void 0 : userIds.length) ? /*#__PURE__*/React.createElement("p", {
    className: "tasks-modal-content-person-name-header-button",
    onClick: function onClick() {
      setUserActive([]);
      setUserSelected(true);
    }
  }, "Unselect All Employees") : /*#__PURE__*/React.createElement("p", {
    //variant="outline-secondary"
    className: "tasks-modal-content-person-name-header-button",
    onClick: function onClick() {
      setUserActive(userIds);
      setUserSelected(true);
    }
  }, "Select All Employees")), /*#__PURE__*/React.createElement("div", {
    className: "tasks-modal-content-person-name-listing"
  }, usersLoading ? /*#__PURE__*/React.createElement(Loader, null) : userDetails && (_userWithSearch = userWithSearch(userDetails)) !== null && _userWithSearch !== void 0 && _userWithSearch.length ? (_userWithSearch2 = userWithSearch(userDetails)) === null || _userWithSearch2 === void 0 ? void 0 : _userWithSearch2.map(function (user, index) {
    var teamFirstName = user.displayName.match(/\b(\w)/g);
    var teamNameIcon = teamFirstName.join("");
    return /*#__PURE__*/React.createElement("div", {
      className: "project-task-modals-content-person-name-listing-card-content",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person",
      onClick: function onClick() {
        setUserSelected(true);
        setUserActive(function (prev) {
          return prev.includes(user.userId) ? prev.filter(function (a) {
            return a !== user.userId;
          }) : [].concat(_toConsumableArray(prev), [user.userId]);
        });
      }
    }, user.profileUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "task-card-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Workfolio",
      src: user === null || user === void 0 ? void 0 : user.profileUrl,
      className: "task-card-avatar-profile-img"
    }))) : /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person-icon"
    }, user.displayName.charAt(0).toUpperCase()), /*#__PURE__*/React.createElement("div", {
      className: "leave-setting-my-projects-modal-content-header-team-name"
    }, user.displayName)), /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-team-name"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      id: user.userId,
      name: "myRadioGroup",
      className: "create-project-team-selection-control-checkbox",
      checked: userActive.includes(user.userId),
      onChange: function onChange() {
        setUserSelected(true);
        setUserActive(function (prev) {
          return prev.includes(user.userId) ? prev.filter(function (a) {
            return a !== user.userId;
          }) : [].concat(_toConsumableArray(prev), [user.userId]);
        });
      }
    })));
  }) : /*#__PURE__*/React.createElement("div", {
    className: "text-muted text-center"
  }, "No member found for \"".concat(searchUser, "\" ")))))), /*#__PURE__*/React.createElement("div", {
    className: "project-task-list-modal-save-button"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "leave-setting-project-task-modals-save-button",
    onClick: function onClick() {
      handleUserSubmitButton();
    },
    disabled: addUserHolidayLoading
  }, addUserHolidayLoading ? "Loading..." : "Done")))));
};
function convertOrganisationTimezoneEdit(sD, tz) {
  var currentSystemTimezone = moment.tz.guess();
  var currentSystemOffset = moment(sD).tz(currentSystemTimezone).utcOffset();
  var zoneoffset = moment(sD).tz(tz).utcOffset();
  var startDate = moment(sD).tz(tz).startOf("day").format("YYYY-MM-DD HH:mm:ss");
  if (zoneoffset < 0) {
    zoneoffset = Math.abs(zoneoffset);
    startDate = moment(startDate).subtract(zoneoffset, "minutes").toDate();
  } else {
    zoneoffset = Math.abs(zoneoffset);
    startDate = moment(startDate).add(zoneoffset, "minutes").toDate();
  }
  if (currentSystemOffset < 0) {
    currentSystemOffset = Math.abs(currentSystemOffset);
    startDate = moment(startDate).add(currentSystemOffset, "minutes").toDate();
  }

  // else {
  //   console.log("else enter");

  //   currentSystemOffset = Math.abs(currentSystemOffset);
  //   startDate = moment(startDate).add(currentSystemOffset, "minutes").toDate();
  // }

  return startDate;
}
var EditHolidayModal = function EditHolidayModal(props) {
  var editHolidayShow = props.editHolidayShow,
    handleEditHolidayClose = props.handleEditHolidayClose,
    organisationSettings = props.organisationSettings,
    organisationId = props.organisationId,
    holidayTypeCheck = props.holidayTypeCheck,
    holidayYear = props.holidayYear,
    timeZone = props.timeZone;
  if (!editHolidayShow) {
    return null;
  }
  var holidayId = editHolidayShow.holidayId,
    dates = editHolidayShow.date,
    title = editHolidayShow.title,
    session = editHolidayShow.session,
    type = editHolidayShow.type,
    holidayVisibility = editHolidayShow.holidayVisibility,
    leaveUser = editHolidayShow.leaveUser;
  var _React$useContext3 = React.useContext(FilterContext),
    teamId = _React$useContext3.teamId,
    role = _React$useContext3.role;
  var editDate = moment.unix(dates / 1000).format("YYYY-MM-DD HH:mm:ss");
  editDate = convertOrganisationTimezoneEdit(editDate, timeZone);
  var _useState17 = useState(editDate),
    _useState18 = _slicedToArray(_useState17, 2),
    startDate = _useState18[0],
    setStartDate = _useState18[1];
  var _React$useState25 = React.useState(""),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    searchUser = _React$useState26[0],
    setSearchUser = _React$useState26[1];
  var _React$useState27 = React.useState(true),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    isUserSelected = _React$useState28[0],
    setUserSelected = _React$useState28[1];
  var _React$useState29 = React.useState(holidayVisibility == "public" || holidayVisibility == null ? false : true),
    _React$useState30 = _slicedToArray(_React$useState29, 2),
    isPriorityCheck = _React$useState30[0],
    setIsPriorityCheck = _React$useState30[1];
  var _useQuery4 = useQuery(GET_USER_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userRole: role
      },
      skip: !organisationId
    }),
    usersLoading = _useQuery4.loading,
    usersData = _useQuery4.data,
    usersError = _useQuery4.error,
    userListRefetch = _useQuery4.refetch;
  var userDetails = !usersLoading && !usersError ? usersData === null || usersData === void 0 ? void 0 : usersData.getUserListing : null;
  var selectedUserIds = [];
  if (leaveUser !== null && leaveUser !== void 0 && leaveUser.length) {
    selectedUserIds = leaveUser.map(function (team) {
      return team.userId;
    });
  }
  var userIds = userDetails === null || userDetails === void 0 ? void 0 : userDetails.map(function (user) {
    return user.userId;
  });
  var _React$useState31 = React.useState(selectedUserIds),
    _React$useState32 = _slicedToArray(_React$useState31, 2),
    userActive = _React$useState32[0],
    setUserActive = _React$useState32[1];
  var _React$useState33 = React.useState(userIds),
    _React$useState34 = _slicedToArray(_React$useState33, 2),
    publicActive = _React$useState34[0],
    setPublicActive = _React$useState34[1];
  React.useEffect(function () {
    var _usersData$getUserLis2;
    var userId = usersData === null || usersData === void 0 ? void 0 : (_usersData$getUserLis2 = usersData.getUserListing) === null || _usersData$getUserLis2 === void 0 ? void 0 : _usersData$getUserLis2.map(function (user) {
      return user.userId;
    });
    setPublicActive(userId);
  }, [usersData]);
  var _useMutation9 = useMutation(EDIT_HOLIDAY_MUTATION),
    _useMutation10 = _slicedToArray(_useMutation9, 2),
    editHoliday = _useMutation10[0],
    editHolidayLoading = _useMutation10[1].loading;
  var handleSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(values, actions) {
      var holidayTitle, date, holidaySession, holidayType, dateTemp, holidayAddResponse;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            holidayTitle = values.holidayTitle, date = values.date, holidaySession = values.holidaySession, holidayType = values.holidayType;
            if (!date) {
              _context5.next = 7;
              break;
            }
            _context5.next = 4;
            return convertOrganisationTimezone(date, timeZone);
          case 4:
            _context5.t0 = _context5.sent;
            _context5.next = 8;
            break;
          case 7:
            _context5.t0 = null;
          case 8:
            dateTemp = _context5.t0;
            _context5.prev = 9;
            _context5.next = 12;
            return editHoliday({
              variables: {
                organisationId: organisationId,
                holidayTitle: holidayTitle,
                date: dateTemp,
                session: holidaySession,
                holidayType: holidayType,
                timeZone: organisationSettings.organisationTimezone,
                holidayId: holidayId,
                holidayVisibility: !isPriorityCheck ? "public" : "private",
                userId: !isPriorityCheck ? publicActive : userActive
              },
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: HOLIDAY_LIST_QUERY,
                variables: {
                  organisationId: organisationId,
                  holidayType: holidayTypeCheck && holidayTypeCheck.value ? holidayTypeCheck.value : null,
                  startYear: moment(holidayYear).format("YYYY"),
                  endYear: moment(holidayYear).format("YYYY"),
                  limit: LIMIT,
                  offset: 0
                }
              }]
            });
          case 12:
            holidayAddResponse = _context5.sent;
            // Resets form after submission is complete
            actions.resetForm();
            actions.setSubmitting(false);
            if (!holidayAddResponse || !holidayAddResponse.data || holidayAddResponse.data.editHoliday == null) {
              toast.error("Error Occurred, Try again later!!!");
            } else {
              // setTeamActive
              toast.success("Holiday updated successfully!");
              handleEditHolidayClose();
            }
            _context5.next = 22;
            break;
          case 18:
            _context5.prev = 18;
            _context5.t1 = _context5["catch"](9);
            if (isRateLimited(_context5.t1)) {
              // A 429 is a network error, so its reason never reaches error.message
              // and would otherwise fail silently here.
              toast.error(rateLimitMessage(_context5.t1));
            } else if (_context5.t1.message.includes("holiday title already exist")) {
              actions.setFieldError("holidayTitle", "holiday title already Exists");
            } else if (_context5.t1.message.includes("holiday date already exist")) {
              actions.setFieldError("date", "Holiday date already Exists");
            }
            actions.setSubmitting(false);
          case 22:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[9, 18]]);
    }));
    return function (_x9, _x10) {
      return _ref10.apply(this, arguments);
    };
  }(), [editHoliday, editHolidayLoading, publicActive, userActive, isPriorityCheck]);
  var handleKey = function handleKey(data) {
    // if (data == "private") {
    setIsPriorityCheck(function (prev) {
      return prev === true ? false : true;
    });
    var t = userDetails === null || userDetails === void 0 ? void 0 : userDetails.map(function (user) {
      return user.userId;
    });
    setPublicActive(t);
    //}
  };
  var userWithSearch = function userWithSearch(userData) {
    if (!searchUser) {
      return userData;
    }
    return userData.filter(function (filterUsersData) {
      var _filterUsersData$disp5, _filterUsersData$disp6, _filterUsersData$disp7, _filterUsersData$disp8;
      return filterUsersData === null || filterUsersData === void 0 ? void 0 : (_filterUsersData$disp5 = filterUsersData.displayName) === null || _filterUsersData$disp5 === void 0 ? void 0 : (_filterUsersData$disp6 = _filterUsersData$disp5.toLowerCase) === null || _filterUsersData$disp6 === void 0 ? void 0 : (_filterUsersData$disp7 = _filterUsersData$disp6.call(_filterUsersData$disp5)) === null || _filterUsersData$disp7 === void 0 ? void 0 : (_filterUsersData$disp8 = _filterUsersData$disp7.includes) === null || _filterUsersData$disp8 === void 0 ? void 0 : _filterUsersData$disp8.call(_filterUsersData$disp7, searchUser.toLowerCase());
    });
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: editHolidayShow,
    onHide: handleEditHolidayClose,
    animation: false,
    size: isPriorityCheck ? "lg" : "md",
    className: "add-holiday-import-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "add-holiday-import-modal-header-title"
  }, "Edit Holiday")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "add-holiday-import-modal-body"
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      date: startDate,
      holidayTitle: title,
      holidaySession: session,
      holidayType: type
    },
    validationSchema: AddHolidaySchema,
    onSubmit: handleSubmit
    //   enableReinitialize={true}
  }, function (_ref11) {
    var _userWithSearch3, _userWithSearch4;
    var setFieldValue = _ref11.setFieldValue,
      errors = _ref11.errors,
      touched = _ref11.touched,
      values = _ref11.values;
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement("div", {
      className: "add-holiday-import-modal-body-wrapper-form"
    }, /*#__PURE__*/React.createElement("div", {
      className: "add-holiday-import-modal-body-wrapper-form-div"
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames("", {
        "leave-grid-for-edit-private": isPriorityCheck
      })
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, " ", /*#__PURE__*/React.createElement(Field, {
      name: "date"
    }, function (_ref12) {
      var field = _ref12.field,
        form = _ref12.form;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "add-holiday-import-modal-body-wrapper-form-div-field-form-group"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "add-holiday-import-modal-body-wrapper-form-div-field-label-name"
      }, "Date"), errors.date && touched.date ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error add-holiday-import-modal-body-input-form-error"
      }, errors.date) : null), /*#__PURE__*/React.createElement(DatePicker, {
        selected: startDate,
        onChange: function onChange(date) {
          setStartDate(date);
          setFieldValue("date", date);
        },
        className: "holiday-import-add-modal-body-wrapper-form-input",
        dateFormat: "dd MMM, yyyy"
      }));
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Field, {
      name: "holidayTitle"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "add-holiday-import-modal-body-wrapper-form-div-group"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "add-holiday-import-modal-body-wrapper-form-div-field-label-name"
      }, "Holiday Title"), errors.holidayTitle && touched.holidayTitle ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error add-holiday-import-modal-body-input-form-error"
      }, errors.holidayTitle) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        type: "text",
        className: "holiday-import-add-modal-body-wrapper-form-input"
      }, field)));
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, " ", /*#__PURE__*/React.createElement(Field, {
      name: "holidaySession"
    }, function (_ref13) {
      var field = _ref13.field,
        form = _ref13.form;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "add-holiday-import-modal-body-wrapper-form-div-group"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "add-holiday-import-modal-body-wrapper-form-div-field-label-name"
      }, "Holiday Session"), errors.holidaySession && touched.holidaySession ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error add-holiday-import-modal-body-input-form-error"
      }, errors.holidaySession) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        as: "select",
        className: "add-holiday-import-modal-body-wrapper-form-div-field-input"
      }, field), /*#__PURE__*/React.createElement("option", {
        key: "select-user",
        value: " "
      }, "Select Holiday Session"), dayTypeList.map(function (key, index) {
        return /*#__PURE__*/React.createElement("option", {
          key: key.value,
          value: key.value
        }, key.name);
      })));
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, " ", /*#__PURE__*/React.createElement(Field, {
      name: "holidayType"
    }, function (_ref14) {
      var field = _ref14.field,
        form = _ref14.form;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "add-holiday-import-modal-body-wrapper-form-div-group"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "add-holiday-import-modal-body-wrapper-form-div-field-label-name"
      }, "Holiday Type"), errors.holidayType && touched.holidayType ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error add-holiday-import-modal-body-input-form-error"
      }, errors.holidayType) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        as: "select",
        className: "add-holiday-import-modal-body-wrapper-form-div-field-input"
      }, field), /*#__PURE__*/React.createElement("option", {
        key: "select-user",
        value: " "
      }, "Select Holiday Type"), holidayTypeList.map(function (key, index) {
        return /*#__PURE__*/React.createElement("option", {
          key: key.value,
          value: key.value
        }, key.name);
      })));
    })))), /*#__PURE__*/React.createElement(Accordion, {
      className: classNames("task-modal-accordion-whole task-editmoldal-accordion", {
        " task-editmoldal-accordion--edit": isPriorityCheck
      }),
      defaultActiveKey: !isPriorityCheck ? null : "0"
    }, /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        return handleKey("setting");
      }
    }, /*#__PURE__*/React.createElement(Accordion.Toggle, {
      as: Button,
      variant: "link",
      eventKey: "0",
      className: "task-modal-content-header-team-name-acc"
    }, /*#__PURE__*/React.createElement("span", {
      className: "project-detail-tasks-modal-content-header-setting"
    }, /*#__PURE__*/React.createElement(HiLockClosed, {
      className: "project-tasks-modal-content-header-setting-icon"
    }), " Assign this leave type to all members"), /*#__PURE__*/React.createElement("div", {
      className: "tasks-rule-uparrow toggle-switch"
    }, /*#__PURE__*/React.createElement("label", {
      "for": "chkTest"
    }, /*#__PURE__*/React.createElement("span", {
      className: classNames("toggle-track", {
        "toggle-track-nav-right-div": !isPriorityCheck
      })
    }))))), /*#__PURE__*/React.createElement(Accordion.Collapse, {
      eventKey: "0"
    }, /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name"
    }, /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-header"
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-edit-modal-content-person-name-header-section"
    }, /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-header-section-label"
    }), /*#__PURE__*/React.createElement("div", {
      className: classNames("my-projects-modal-content-person-name-header-section-content", {
        "my-projects-modal-content-person-name-header-section-content--edit": isPriorityCheck
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-searchbox-wrapper"
    }, /*#__PURE__*/React.createElement(SearchBar, {
      value: searchUser,
      onChange: setSearchUser,
      placeholder: "Search employee name"
    })), (userActive === null || userActive === void 0 ? void 0 : userActive.length) == (userIds === null || userIds === void 0 ? void 0 : userIds.length) ? /*#__PURE__*/React.createElement("p", {
      className: "projects-tasks-modal-content-person-name-header-button",
      onClick: function onClick() {
        setUserActive([]);
        setUserSelected(false);
      }
    }, "Unselect All") : /*#__PURE__*/React.createElement("p", {
      //variant="outline-secondary"
      className: "projects-tasks-modal-content-person-name-header-button",
      onClick: function onClick() {
        setUserActive(userIds);
        setUserSelected(true);
      }
    }, "Select All")))), /*#__PURE__*/React.createElement("div", {
      className: classNames("project-details-tasks-modal-content-person-name-listing", {
        "holiday-project-details-tasks-modal-content-person-name-listing--edit": isPriorityCheck
      })
    }, usersLoading ? /*#__PURE__*/React.createElement(Loader, null) : userDetails && (_userWithSearch3 = userWithSearch(userDetails)) !== null && _userWithSearch3 !== void 0 && _userWithSearch3.length ? (_userWithSearch4 = userWithSearch(userDetails)) === null || _userWithSearch4 === void 0 ? void 0 : _userWithSearch4.map(function (user, index) {
      var teamFirstName = user.displayName.match(/\b(\w)/g);
      var teamNameIcon = teamFirstName.join("");
      return /*#__PURE__*/React.createElement("div", {
        className: "my-projects-modal-content-person-name-listing-card-content",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "tasks-modal-content-person-name-listing-card-content-person",
        onClick: function onClick() {
          setUserSelected(true);
          setUserActive(function (prev) {
            return prev.includes(user.userId) ? prev.filter(function (a) {
              return a !== user.userId;
            }) : [].concat(_toConsumableArray(prev), [user.userId]);
          });
        }
      }, user.profileUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "task-card-avatar-profile"
      }, /*#__PURE__*/React.createElement("img", {
        alt: "Workfolio",
        src: user === null || user === void 0 ? void 0 : user.profileUrl,
        className: "task-card-avatar-profile-img"
      }))) : /*#__PURE__*/React.createElement("div", {
        className: "tasks-modal-content-person-name-listing-card-content-person-icon"
      }, user.displayName.charAt(0).toUpperCase()), /*#__PURE__*/React.createElement("div", {
        className: "my-projects-modal-content-header-team-name--edit"
      }, user.displayName)), /*#__PURE__*/React.createElement("div", {
        className: "my-projects-modal-content-team-name"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: user.userId,
        name: "myRadioGroup",
        className: "create-project-team-selection-control-checkbox",
        checked: userActive.includes(user.userId),
        onChange: function onChange() {
          setUserSelected(true);
          setUserActive(function (prev) {
            return prev.includes(user.userId) ? prev.filter(function (a) {
              return a !== user.userId;
            }) : [].concat(_toConsumableArray(prev), [user.userId]);
          });
        }
      })));
    }) : /*#__PURE__*/React.createElement("div", {
      className: "text-muted text-center"
    }, "No member found for \"".concat(searchUser, "\""))))))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, " ", /*#__PURE__*/React.createElement("div", {
      className: "add-holiday-import-footer-add-holiday-import-button"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      className: "add-holiday-import-footer-add-holiday-add-button",
      type: "submit",
      disabled: editHolidayLoading
    }, editHolidayLoading ? "Loading..." : "Save Changes"), /*#__PURE__*/React.createElement(Button, {
      variant: "secondary",
      className: "add-holiday-import-footer-add-holiday-cancel-button"
      // type="close"
      ,
      onClick: function onClick() {
        return handleEditHolidayClose();
      }
    }, "Cancel")))))))));
  })));
};
var DeleteHolidayModal = function DeleteHolidayModal(props) {
  var organisationId = props.organisationId,
    deleteHolidayShow = props.deleteHolidayShow,
    handleDeleteHolidayClose = props.handleDeleteHolidayClose,
    holidayTypeCheck = props.holidayTypeCheck,
    holidayYear = props.holidayYear;
  if (deleteHolidayShow == null) {
    return null;
  }
  var _useMutation11 = useMutation(DELETE_HOLIDAY_MUTATION),
    _useMutation12 = _slicedToArray(_useMutation11, 2),
    deleteHoliday = _useMutation12[0],
    deleteHolidayLoading = _useMutation12[1].loading;
  var handleDeleteTask = React.useCallback(function () {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      var response;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            if (!deleteHolidayLoading) {
              _context6.next = 2;
              break;
            }
            return _context6.abrupt("return");
          case 2:
            _context6.next = 4;
            return deleteHoliday({
              variables: {
                organisationId: organisationId,
                holidayId: deleteHolidayShow
              },
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: HOLIDAY_LIST_QUERY,
                variables: {
                  organisationId: organisationId,
                  holidayType: holidayTypeCheck && holidayTypeCheck.value ? holidayTypeCheck.value : null,
                  startYear: moment(holidayYear).format("YYYY"),
                  endYear: moment(holidayYear).format("YYYY"),
                  limit: LIMIT,
                  offset: 0
                }
              }]
            });
          case 4:
            response = _context6.sent;
            if (!(!response || !response.data || response.data.deleteHoliday === null)) {
              _context6.next = 10;
              break;
            }
            throw new Error("error");
          case 10:
            handleDeleteHolidayClose();
            toast.success("Holiday deleted successfully!");
          case 12:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
  }, [deleteHoliday, deleteHolidayLoading]);
  return /*#__PURE__*/React.createElement(Modal, {
    show: deleteHolidayShow,
    onHide: handleDeleteHolidayClose
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, "Delete Holiday")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, "Are you sure you want to delete this holiday?"), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: handleDeleteHolidayClose
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "danger",
    className: "project-details-task-card-delete-button",
    onClick: handleDeleteTask(),
    disabled: deleteHolidayLoading ? true : false
  }, deleteHolidayLoading ? "Loading..." : "Delete")));
};
export var ImportModal = function ImportModal(props) {
  var _lastYearHolidayData$5, _lastYearHolidayData$6;
  var importShow = props.importShow,
    setImportButton = props.setImportButton,
    handleImportClose = props.handleImportClose,
    organisationId = props.organisationId,
    timeZone = props.timeZone,
    holidayYear = props.holidayYear,
    handleOldImportData = props.handleOldImportData,
    addOldHolidayLoading = props.addOldHolidayLoading,
    handleOldImportDataNo = props.handleOldImportDataNo,
    addOldNoHolidayLoading = props.addOldNoHolidayLoading,
    lastYearHolidayData = props.lastYearHolidayData;
  if (importShow == false) {
    return null;
  }
  var _React$useContext4 = React.useContext(FilterContext),
    organisationSettings = _React$useContext4.organisationSettings,
    role = _React$useContext4.role;
  var _React$useState35 = React.useState([]),
    _React$useState36 = _slicedToArray(_React$useState35, 2),
    tempData = _React$useState36[0],
    setTempData = _React$useState36[1];
  var _React$useState37 = React.useState([]),
    _React$useState38 = _slicedToArray(_React$useState37, 2),
    arrayData = _React$useState38[0],
    setArrayData = _React$useState38[1];
  var _React$useState39 = React.useState(""),
    _React$useState40 = _slicedToArray(_React$useState39, 2),
    fileName = _React$useState40[0],
    setfileName = _React$useState40[1];
  var _React$useState41 = React.useState(""),
    _React$useState42 = _slicedToArray(_React$useState41, 2),
    errorMsg = _React$useState42[0],
    setErrorMsg = _React$useState42[1];
  var _React$useContext5 = React.useContext(UserContext),
    user = _React$useContext5.user;
  React.useEffect(function () {
    if (tempData.length) {
      var tempArray = [];
      tempData.map(function (item) {
        if (item !== null && item !== void 0 && item["Date(DD-MM-YYYY)"]) {
          if (moment(item === null || item === void 0 ? void 0 : item["Date(DD-MM-YYYY)"], "DD-MM-YYYY", true).isValid() || moment(item === null || item === void 0 ? void 0 : item["Date(DD-MM-YYYY)"], "DD/MM/YYYY", true).isValid()) {
            var date = item === null || item === void 0 ? void 0 : item["Date(DD-MM-YYYY)"];
            var splitDate = item === null || item === void 0 ? void 0 : item["Date(DD-MM-YYYY)"].split("/");
            if (splitDate.length > 1) {
              date = date.replace(("/", "-"));
            }
            return tempArray.push({
              holidayTitle: item === null || item === void 0 ? void 0 : item.Title,
              holidayDate: date
            });
          } else {
            setErrorMsg("all");
            return;
          }
        }
      });
      if (tempArray.length) {
        setErrorMsg("");
      } else {
        setErrorMsg("all");
      }
      setArrayData(tempArray);
    }
  }, [tempData]);
  var _useMutation13 = useMutation(IMPORT_HOLIDAY_MUTATION),
    _useMutation14 = _slicedToArray(_useMutation13, 2),
    importHoliday = _useMutation14[0],
    importDetailsLoading = _useMutation14[1].loading;
  var handleSubmit = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
    var variables, response, _response$data, serverMessage;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          if (!(arrayData.length == 0)) {
            _context7.next = 3;
            break;
          }
          if (fileName == "") {
            setErrorMsg("no file name");
          } else {
            setErrorMsg("all");
          }
          return _context7.abrupt("return");
        case 3:
          if (!(arrayData.length >= 60)) {
            _context7.next = 6;
            break;
          }
          setErrorMsg("You've reached the maximum of 60 active holidays for this year. Please delete an existing holiday before adding a new one. For any queries, please contact the GetWorkfolio support team.");
          return _context7.abrupt("return");
        case 6:
          variables = {
            organisationId: organisationId,
            holidayDataArray: arrayData,
            timeZone: timeZone
          };
          _context7.prev = 7;
          _context7.next = 10;
          return importHoliday({
            variables: variables,
            awaitRefetchQueries: true,
            refetchQueries: [{
              query: HOLIDAY_LIST_QUERY,
              variables: {
                organisationId: organisationId,
                holidayType: null,
                startYear: moment(holidayYear).format("YYYY"),
                endYear: moment(holidayYear).format("YYYY"),
                limit: LIMIT,
                offset: 0
              }
            }, {
              query: LAST_YEAR_HOLIDAY_QUERY,
              variables: {
                organisationId: organisationId,
                year: moment(holidayYear).format("YYYY"),
                timeZone: timeZone
              }
            }]
          });
        case 10:
          response = _context7.sent;
          if (!response || !response.data || response.data.importHoliday == "true") {
            if (response && (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.importHoliday) == "true") {
              toast.success("Holiday imported successfully!");
              handleImportClose();
            } else {
              toast.error("Error ");
            }
          }
          _context7.next = 18;
          break;
        case 14:
          _context7.prev = 14;
          _context7.t0 = _context7["catch"](7);
          // These tested bare string literals, which are always truthy - so every
          // failure, the holiday cap and a 429 included, reported "Holiday date
          // already exists". The message has to be read off the error.
          serverMessage = ((_context7.t0 === null || _context7.t0 === void 0 ? void 0 : _context7.t0.message) || "").toLowerCase();
          if (isRateLimited(_context7.t0)) {
            setErrorMsg(rateLimitMessage(_context7.t0));
          } else if (serverMessage.includes("holiday date already exist")) {
            setErrorMsg("Holiday date already exists");
          } else if (serverMessage.includes("holiday title already exist")) {
            setErrorMsg("Holiday title already exists");
          } else if (_context7.t0 !== null && _context7.t0 !== void 0 && _context7.t0.message) {
            // Covers the server's own holiday-cap message for a file small enough
            // to pass the pre-check above but still over the limit once the existing
            // holidays are counted.
            setErrorMsg(_context7.t0.message);
          } else {
            setErrorMsg("all");
          }
        case 18:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[7, 14]]);
  })), [importHoliday, importDetailsLoading, arrayData]);
  var handleImport = function handleImport(event) {
    var files = event.target.files;
    if (files.length) {
      var file = files[0];
      setfileName(file.name);
      var reader = new FileReader();
      reader.onload = function (event) {
        var readOpts = {
          // <--- need these settings in readFile options
          raw: false,
          cellDates: true,
          dateNF: "DD/MM/YYYY"
        };
        var wb = read(event.target.result, {
          type: "binary",
          cellText: false,
          cellDates: true
        });
        var sheets = wb.SheetNames;
        if (sheets.length) {
          var rows = utils.sheet_to_json(wb.Sheets[sheets], readOpts);
          //console.log({rows});
          setTempData(rows);
        }
      };
      reader.readAsArrayBuffer(file);
    }
  };
  var getExportData = /*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
      var wb, ws, buf, fileName;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            wb = new Excel.Workbook();
            ws = wb.addWorksheet();
            ws.columns = [{
              header: "Title",
              key: "title",
              width: 30,
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Date(DD-MM-YYYY)",
              key: "date",
              width: 20,
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }];
            ws.addRow({
              title: "New Year",
              date: "01-01-2023"
            });
            ws.addRow({
              title: "Pongal",
              date: "14-01-2023"
            });
            ws.getCell("A1").font = {
              bold: true
            };
            ws.getCell("B1").font = {
              bold: true
            };
            _context8.next = 9;
            return wb.xlsx.writeBuffer();
          case 9:
            buf = _context8.sent;
            fileName = "workfolio-holidays-template.xlsx";
            saveAs(new Blob([buf]), fileName);
          case 12:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function getExportData() {
      return _ref17.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleImportClose,
    centered: true,
    className: "project-task-modals-root"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-task-modals-root-title"
  }, "Holidays Import from File")), role !== "Member" ? /*#__PURE__*/React.createElement(React.Fragment, null, lastYearHolidayData !== null && lastYearHolidayData !== void 0 && lastYearHolidayData.importOldHolidayList && (lastYearHolidayData === null || lastYearHolidayData === void 0 ? void 0 : (_lastYearHolidayData$5 = lastYearHolidayData.importOldHolidayList) === null || _lastYearHolidayData$5 === void 0 ? void 0 : _lastYearHolidayData$5.year) == "" && (lastYearHolidayData === null || lastYearHolidayData === void 0 ? void 0 : (_lastYearHolidayData$6 = lastYearHolidayData.importOldHolidayList) === null || _lastYearHolidayData$6 === void 0 ? void 0 : _lastYearHolidayData$6.lastYear) == "true" ? /*#__PURE__*/React.createElement("div", {
    className: "holiday-list-import-old-data-text-div-add-import"
  }, /*#__PURE__*/React.createElement(FaRegLightbulb, {
    className: "holiday-list-import-old-data-text-span-icon"
  }), " Do you want to import last year's holidays?", " ", /*#__PURE__*/React.createElement("span", {
    className: "holiday-list-import-old-data-text-span",
    onClick: function onClick() {
      handleOldImportData();
    }
  }, addOldHolidayLoading ? "Loading" : "Yes"), " ", "or", " ", /*#__PURE__*/React.createElement("span", {
    className: "holiday-list-import-old-data-text-span",
    onClick: function onClick() {
      handleOldImportDataNo();
    }
  }, addOldNoHolidayLoading ? "Loading" : "No")) : null) : null, /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "import-tsk-modal-alert-text"
  }, /*#__PURE__*/React.createElement("p", {
    className: "tasks-import-modal-p"
  }, "How to import holidays?"), /*#__PURE__*/React.createElement("p", {
    className: "tasks-import-modal-p-export"
  }, "Download the excel template from", /*#__PURE__*/React.createElement("span", {
    className: "task-import-download-icon-btn",
    onClick: function onClick() {
      getExportData();
    }
  }, " ", "here"), " ", "and edit the template.")), /*#__PURE__*/React.createElement("p", {
    className: "tasks-import-modal-p-label"
  }, "Import the edited template here"), /*#__PURE__*/React.createElement("div", {
    className: "tasks-modal-content-person-name"
  }, /*#__PURE__*/React.createElement("div", {
    className: "custom-file project-details-import-task-modal"
  }, /*#__PURE__*/React.createElement("input", {
    type: "file",
    name: "file",
    className: "custom-file-input",
    id: "inputGroupFile",
    required: true,
    onChange: function onChange(e) {
      return handleImport(e);
    },
    accept: ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
  }), /*#__PURE__*/React.createElement("label", {
    className: "custom-file-label",
    htmlFor: "inputGroupFile"
  }, fileName == "" ? "Choose file (.csv or .xlsx)" : fileName)), errorMsg == "all" ? /*#__PURE__*/React.createElement("div", {
    className: "import-tasks-modal-error"
  }, "Pls check the uploaded file, it's not matching with the given template") : errorMsg == "Holiday title already exists" ? /*#__PURE__*/React.createElement("div", {
    className: "import-tasks-modal-error"
  }, " Holiday title already exists ") : errorMsg == "Holiday date already exists" ? /*#__PURE__*/React.createElement("div", {
    className: "import-tasks-modal-error"
  }, " Holiday date already exists ") : errorMsg == "no file name" ? /*#__PURE__*/React.createElement("div", {
    className: "import-tasks-modal-error"
  }, " Please select a file ") : errorMsg !== "" ?
  /*#__PURE__*/
  // Anything else is a real message - the holiday cap, a 429, or a
  // server error - shown as it arrives rather than needing its own
  // sentinel added to this chain.
  React.createElement("div", {
    className: "import-tasks-modal-error"
  }, " ", errorMsg, " ") : null, /*#__PURE__*/React.createElement("div", {
    className: "project-task-list-modal-save-button"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "project-task-modals-save-button",
    onClick: function onClick() {
      handleSubmit();
    },
    disabled: importDetailsLoading,
    type: "submit"
  }, importDetailsLoading ? "Loading..." : "Import Holiday"))))));
};
var ViewDetailsModal = function ViewDetailsModal(props) {
  var holidayViewShow = props.holidayViewShow,
    handleHolidayViewClose = props.handleHolidayViewClose;
  if (holidayViewShow == null) {
    return null;
  }
  var title = holidayViewShow.title,
    dateFormat = holidayViewShow.dateFormat,
    day = holidayViewShow.day,
    session = holidayViewShow.session,
    type = holidayViewShow.type,
    holidayVisibility = holidayViewShow.holidayVisibility,
    leaveUser = holidayViewShow.leaveUser;
  return /*#__PURE__*/React.createElement(Modal, {
    show: holidayViewShow,
    onHide: handleHolidayViewClose,
    centered: true,
    size: "md",
    className: "task-tracker-task-detail-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "task-tracker-task-detail-modal-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "task-tracker-task-detail-modal-title"
  }, title)), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "task-overview-detail-modal-body "
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-overview-modal-body-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header"
  }, " Holiday Date & Day"), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-content"
  }, /*#__PURE__*/React.createElement(FiCalendar, {
    className: "leave-view-modal-content-whole-div-content-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-content"
  }, dateFormat, " (", day, ")"))), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header"
  }, " Session "), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-content"
  }, /*#__PURE__*/React.createElement(GiSandsOfTime, {
    className: "leave-view-modal-content-whole-div-content-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-content"
  }, session == "full-day" ? "Full Day" : session == "half-day-first-half" ? "Half Day - 1st Half" : "Half Day - 2nd Half"))), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header"
  }, "Holiday Type "), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-content"
  }, /*#__PURE__*/React.createElement(BsInfoCircle, {
    className: "leave-view-modal-content-whole-div-content-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-content"
  }, type == "public-holiday" ? "Public Holiday" : type == "office-holiday" ? "Office Holiday" : "Floater Holiday"))), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header"
  }, "Visibility "), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-content"
  }, holidayVisibility == "private" ? /*#__PURE__*/React.createElement(FiLock, {
    className: "leave-view-modal-content-whole-div-content-icon"
  }) : /*#__PURE__*/React.createElement(FiUnlock, {
    className: "leave-view-modal-content-whole-div-content-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-content"
  }, holidayVisibility == "private" ? "Selected Members" : " All Employees"))), holidayVisibility == "private" ? /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header"
  }, "Holiday Visible To ", /*#__PURE__*/React.createElement("span", null, "(", leaveUser.length, " Employees)"), " "), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-content-emp"
  }, leaveUser === null || leaveUser === void 0 ? void 0 : leaveUser.map(function (employeeData, key) {
    var _employeeData$display;
    return /*#__PURE__*/React.createElement("div", {
      className: "leave-view-modal-content-whole-div-header-content"
    }, (employeeData === null || employeeData === void 0 ? void 0 : employeeData.profileUrl) === null || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.profileUrl) === "" ? /*#__PURE__*/React.createElement("div", {
      className: "project-details-task-card-avatar"
    }, employeeData === null || employeeData === void 0 ? void 0 : (_employeeData$display = employeeData.displayName) === null || _employeeData$display === void 0 ? void 0 : _employeeData$display.charAt(0).toUpperCase()) : /*#__PURE__*/React.createElement("div", {
      className: "project-details-task-detail-card-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "DeskTime",
      src: employeeData === null || employeeData === void 0 ? void 0 : employeeData.profileUrl,
      className: "project-details-task-detail-card-avatar-profile-img"
    })), /*#__PURE__*/React.createElement("p", {
      className: "leave-view-modal-content-whole-div-content-p"
    }, employeeData === null || employeeData === void 0 ? void 0 : employeeData.displayName));
  }))) : null), /*#__PURE__*/React.createElement("div", null)))));
};
export default HolidayImport;